import { useSelector } from 'react-redux'
import { HIDE_INBOX_SEARCH_FILTER_CALLOUT } from 'ducks/flags/flagNames'
import { selectFlag } from 'ducks/flags'
import FeatureCallout from '@groovehq/internal-design-system/lib/components/FeatureCallout/FeatureCallout'
import {
  heading,
  text,
} from '@groovehq/internal-design-system/lib/styles/elements'
import { css } from '@emotion/react'
import { selectFeatureCalloutExpired } from 'selectors/app'

const holderStyle = css`
  bottom: 0;
  width: 100%;
  position: absolute;
`

const InboxSearchFilterCallout = () => {
  const shouldHide = useSelector(state =>
    selectFlag(state)(HIDE_INBOX_SEARCH_FILTER_CALLOUT)
  )
  const featureCalloutExpired = useSelector(state =>
    selectFeatureCalloutExpired(state, '2023-03-24T00:00:00')
  )

  const overlay = (
    <div>
      <h5
        className="grui my-4"
        css={[heading.styles.h5, text.styles.textWhite]}
      >
        {`✨ New ${app.t('mailbox')} filter!`}
      </h5>
      {`Exciting news! We've added a brand new filter that allows you to search by a specific ${app.t(
        'Mailbox'
      )}!`}
    </div>
  )

  if (featureCalloutExpired || shouldHide !== false) {
    return null
  }

  return (
    <FeatureCallout overlay={overlay} open position="bottom" offset={25}>
      <div css={holderStyle} />
    </FeatureCallout>
  )
}

export default InboxSearchFilterCallout
